import { NumberDecimalFormat } from '@components/shared/Format'
import { Store } from '@stores/Store'

export class SummaryCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Summary Total Income

  get totalCorePlanIncomeMonthlyAmount() {
    const { store } = this
    const { retailMarginAmount, performanceBonus, leadershipBonus, fosterBonus, rubyBonus } = store
    const { depthBonus } = store.depthCalculation

    return NumberDecimalFormat(retailMarginAmount + performanceBonus + leadershipBonus + fosterBonus + rubyBonus + depthBonus)
  }

  get totalCorePlanIncomeAnnualAmount() {
    return this.totalCorePlanIncomeMonthlyAmount * 12
  }

  get totalCorePlusMonthlyAmount() {
    const { store } = this
    const { pathToBronzeMonthlyAmount } = store.pathToBronzeCalculation
    const { bronzeFoundationMonthlyBonusAmount, bronzeBuilderMonthlyBonusAmount } = store.bronzeIncentiveCalculation
    const { performancePlusMonthlyAmount } = store.performancePlusCalculation

    return pathToBronzeMonthlyAmount + bronzeFoundationMonthlyBonusAmount + bronzeBuilderMonthlyBonusAmount + performancePlusMonthlyAmount
  }

  // Path to Bronze is deliberately absent here, it never contributes to annual
  // totals (max 12 payments with monthly re-qualification, the summary renders
  // an info tooltip instead of amount x 12)
  get totalCorePlusAnnualAmount() {
    const { store } = this
    const { bronzeFoundationAnnualBonusAmount, bronzeBuilderAnnualBonusAmount } = store.bronzeIncentiveCalculation
    const { bronzeBuilderConsitencyIncentiveAmount } = store.bronzeConsistencyIncentiveCalculation
    const { performancePlusAnnualAmount } = store.performancePlusCalculation
    const { leadershipPlusIncentive } = store.leadershipPlusIncentiveCalculation
    const { twoTimeCashIncentiveAmount } = store.twoTimeCashIncentiveCalculation

    return bronzeFoundationAnnualBonusAmount + bronzeBuilderAnnualBonusAmount +
      bronzeBuilderConsitencyIncentiveAmount + performancePlusAnnualAmount +
      leadershipPlusIncentive + twoTimeCashIncentiveAmount
  }

  get totalIncomeMonthlyAmount() {
    const { totalCorePlanIncomeMonthlyAmount, totalCorePlusMonthlyAmount } = this
    return totalCorePlanIncomeMonthlyAmount + totalCorePlusMonthlyAmount
  }

  get totalIncomeAnnualAmount() {
    const { totalCorePlanIncomeAnnualAmount, totalCorePlusAnnualAmount } = this
    return totalCorePlanIncomeAnnualAmount + totalCorePlusAnnualAmount
  }

}
